import React, { createContext, useContext, useState } from 'react';

// Créer le contexte
const FavoritesUpdateContext = createContext();

// Hook personnalisé
export const useFavoritesUpdate = () => useContext(FavoritesUpdateContext);

// Provider du contexte
export const FavoritesUpdateProvider = ({ children }) => {
  const [updateTrigger, setUpdateTrigger] = useState(0);

  // Fonction pour déclencher une mise à jour
  const triggerUpdate = () => {
    setUpdateTrigger(prev => prev + 1);
  };

  return (
    <FavoritesUpdateContext.Provider value={{ updateTrigger, triggerUpdate }}>
      {children}
    </FavoritesUpdateContext.Provider>
  );
};

export default FavoritesUpdateContext;